import { computed, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { filter, map, of, take } from 'rxjs';
import { ProviderStore } from '../../store/provider/provider.store';
import { ClinicStore } from '../../store/clinic/clinic.store';
import { DocumentStore } from '../../../features/admin/state/document.store';
import { toObservable } from '@angular/core/rxjs-interop';
import { ClinicLocationStore } from '../../store/clinic/clinic-location.store';

export const getClinicDataResolver: ResolveFn<any> = (route, state) => {
  
  const providerStore = inject(ProviderStore)
  const clinicStore = inject(ClinicStore)
  const clinicLocationStore = inject(ClinicLocationStore)
  const documentStore = inject(DocumentStore)

  // step 1: aquire clinic_id
  const clinic_id = Number(route.paramMap.get('clinic_id'))
  providerStore.setActiveClinicId(clinic_id)
  clinicLocationStore.setActiveClinicId(clinic_id)
  providerStore.getProvidersByClinicId({
    clinic_id,
    onSuccess: (providers: any) => {
      const primaryProviderId = providerStore.providerProviderId()

      clinicStore.getClinicDemographics({
        clinic_id,
        provider_id: primaryProviderId ?? 0,
        onSuccess: () => {
          clinicLocationStore.setClinicLocations(clinicStore.locations())
          documentStore.loadDocumentsByClinic(clinic_id)
          
        }
      })
    }
  })

  return toObservable(
      computed(() => ({
          status: documentStore.documentStatus(),
          found: documentStore.entities().length > 0
      }))
  ).pipe(
      filter(({status}) => status === 'success' || status === 'error'),
      take(1),
      map(({found}) => found)
  )
};
